import React, { useState } from 'react';
import TaskListBase from './TaskListBase.jsx';
import TaskLayout from './TaskLayout.jsx';
import NewTaskButton from './top/NewTaskButton.jsx';
import TaskColumnSelector from './top/TaskColumnSelector.jsx';
import TaskSearchBar from './top/TaskSearchBar.jsx';
import TaskServerSideDatagrid from './datagrid/TaskServerSideDatagrid.jsx';
import ToggleButtonGroup from '../common/ToggleButtonGroup.jsx';
import TaskServerSideKanbanView from './datagrid/TaskServerSideKanbanView.jsx';
import Button from '../bootstrap/Button.jsx';
import { FaIcon } from '../common/Icons.jsx';
import PresetDropdown from './top/PresetDropdown.jsx';
import queryClient from '../../../query_client.js';
import TaskGanttView from './datagrid/TaskGanttView.jsx';

const BASE_QUERY_KEY = 'tasksProgrammeTasksList';

function TaskProgrammeTasksList({ projectId, permissions, advancedFeatures }) {
  const [reloadClick, setReloadClick] = useState(0);

  return (
    <TaskListBase projectId={projectId} views={['list', 'kanban', 'gantt']}>
      {({
        btnStyle,
        groupGridItems,
        activeView,
        gridGroupToggleProps,
        listKanbanToggleProps,
        ganttScale,
        ganttView,
        ganttScaleToggleProps,
        ganttViewToggleProps
      }) => (
        <TaskLayout
          left={<>
            {permissions.create_task && (
              <NewTaskButton projectId={projectId} portalProps={{ projectId }} btnStyle={btnStyle} />
            )}
            <TaskColumnSelector projectId={projectId} btnStyle={btnStyle} />
            {advancedFeatures && <ToggleButtonGroup {...listKanbanToggleProps} />}
            {activeView === 'list' && <ToggleButtonGroup {...gridGroupToggleProps} />}
            {activeView === 'gantt' && <ToggleButtonGroup {...ganttScaleToggleProps} />}
            {activeView === 'gantt' && <ToggleButtonGroup {...ganttViewToggleProps} />}
            <Button type='default' style={btnStyle} onClick={() => {
              queryClient.invalidateQueries([BASE_QUERY_KEY]);
              setReloadClick(prev => prev + 1);
            }} title={I18n.t('refresh')}>
              <FaIcon type='refresh' />
            </Button>
          </>}
          right={<TaskSearchBar />}
        >
          {activeView === 'list' && <TaskServerSideDatagrid
            projectId={projectId}
            groupGridItems={groupGridItems}
            permissions={permissions}
            baseQueryKey={BASE_QUERY_KEY}
            reloadClick={reloadClick}
            advancedFeatures={advancedFeatures}
            programmeTasks={true}
          />}
          {activeView === 'kanban' && <TaskServerSideKanbanView
            projectId={projectId}
            permissions={permissions}
            baseQueryKey={BASE_QUERY_KEY}
            reloadClick={reloadClick}
            programmeTasks={true}
          />}
          {activeView === 'gantt' && <TaskGanttView
            projectId={projectId}
            programmeTasks={true}
            scale={ganttScale}
            ganttView={ganttView}
            permissions={permissions}
            advancedFeatures={advancedFeatures}
          />}
        </TaskLayout>
      )}
    </TaskListBase>
  );
}

export default TaskProgrammeTasksList;
